import { render, staticRenderFns } from "./LocalesEnglish.vue?vue&type=template&id=0143863e"
import script from "./LocalesEnglish.vue?vue&type=script&lang=js"
export * from "./LocalesEnglish.vue?vue&type=script&lang=js"
import style0 from "./LocalesEnglish.vue?vue&type=style&index=0&id=0143863e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports